export default {
  title: 'Modelos Ad-Hoc',
  createButton: 'Criar Modelo Ad-Hoc',
  searchLabel: 'Buscar',
  ok: 'Ok',
  headers: {
    modelName: 'Nome do Modelo',
    codename: 'Nome Código',
    pkl: 'PKL',
    pklSize: 'Tamanho PKL',
    modified: 'Modificado',
    status: 'Status',
    actions: 'Ações'
  },
  tooltips: {
    recalculateModelReport: 'Recalcular Relatório do Modelo',
    editAdHocModel: 'Editar Modelo Ad-Hoc',
    deploy: 'Implantar',
    deleteAdHocModel: 'Excluir Modelo Ad-Hoc',
    version: 'Versão'
  },
  deployDialog: {
    title: 'Implantar Modelo',
    sourceModelName: 'Nome do modelo origem',
    targetModelName: 'Nome do modelo destino',
    targetEnvironment: 'Ambiente destino:',
    confirmLabel: "Digite 'deploy' para confirmar a implantação no ambiente selecionado",
    cancel: 'Cancelar',
    deploy: 'Implantar',
    deploying: 'Implantando modelo... Por favor aguarde alguns segundos',
    modelSuccessfullyDeployed: 'Modelo implantado com sucesso',
    errorModelNameExists: 'O nome do modelo já existe no ambiente destino',
    internalError: 'Erro interno'
  },
  deleteDialog: {
    title: 'Aviso',
    deletingAdHocModel: 'Excluindo Modelo Ad-Hoc:',
    confirmMessage: 'Você poderá recuperá-lo durante 7 dias solicitando a um administrador. Tem certeza?',
    cancel: 'Cancelar',
    delete: 'Excluir'
  },
  current: 'atual',
  versionDeployed: 'Implantada em {date}',
  versionTooltip: 'Versão de {name}',
  versionDialog: {
    title: 'Versão do modelo',
    cancel: 'Cancelar',
    save: 'Salvar',
    linked: '{name} agora é a v{version}. Acesso copiado para {grants} usuários e {groups} grupos.'
  },
  versionErrors: {
    notLatestVersion: 'Só a última versão de uma família pode ser desvinculada',
    alreadyInFamily: 'Este modelo já é versão de outro modelo. Desvincule-o primeiro',
    isFamilyRoot: 'Este modelo é a primeira versão da sua própria família, então não pode ser versão de outro modelo',
    familyNotFound: 'O modelo selecionado não existe mais',
    modelNotFound: 'Este modelo não existe mais',
    notAdHoc: 'Só modelos Ad-Hoc podem ter versões',
    internal: 'Não foi possível salvar a versão',
    linkOnCreate: '{name} foi criado, mas não pôde ser vinculado como nova versão: {reason}'
  },
  snackbar: {
    recalculating: 'Recalculando relatório do modelo para {name}...',
    recalculationStarted: 'O recálculo do relatório do modelo para {name} foi iniciado. Você será notificado quando estiver pronto.',
    recalculationError: 'Erro ao recalcular o relatório do modelo para {name}',
    deleteError: 'Erro ao excluir {name}'
  }
}
